import { gql, useMutation } from '@apollo/client';
export const UPDATE_CASES_CHECKLIST = gql`
  mutation ($checklist: [CheckListCasesDtoInput], $id: Long!) {
    cases_update_checklist(checklist: $checklist, id: $id)
  }
`;
export const useLazyMutationUpdateCasesChecklist = options => {
  return useMutation(UPDATE_CASES_CHECKLIST, options !== null && options !== void 0 ? options : {
    errorPolicy: 'ignore'
  });
};